import React from 'react'
import '../../styles/sass/_Skills2.css'
import { Col } from 'react-bootstrap'

/* const SkillItem = ({ perComplete, skill, percentage, classComplete }) => {
    return (
        <li>
            <div className="progress">
                <div className="progress-bar" role="progressbar" id={classComplete} data-percent="80%">
                    <span className="sr-only">{perComplete}</span>
                </div>
                <span className="progress-type">{skill}</span>
                {//<span className="progress-completed">{percentage}</span>1/}
            </div>
        </li>
    )
} */

const TechItem = ({ idClass, skill }) => {
  const style = {
    padding: '5px 20px'
  }
  return (
    <div>
      <Col lg={3} md={3} sm={4} xsHidden style={style}>
        <div className={'progress-radial ' + idClass} >
          <div className={'overlay ' + skill}></div>
        </div>
      </Col>
      <Col lgHidden mdHidden smHidden xs={4} style={style}>
        <div>
          <div className={'techSkillImage ' + skill}></div>
        </div>
      </Col>
    </div>
  )
}

const Code = ({ bio, isSpanish }) => {
  const codeSkills = bio.map((item, index) => {
    return (
      item.code.map((c, idx) => {
        return <TechItem
          key={idx}
          idClass={c.class}
          skill={c.image}
        />
      })
    )
  })
  return (
    <div className='section--professional__tech'>
      <h3 className='section-item-title-2'><i className='fa fa-code'></i>&nbsp;&nbsp; {isSpanish === true ? 'Habilidades Técnicas' : 'Tech Skills'}</h3>
      <div className='skillTechs'>
        {codeSkills}
      </div>
    </div>
  )
}

export default Code



// WEBPACK FOOTER //
// ./src/components/Skills/Tech.js